// extracted by mini-css-extract-plugin
module.exports = {"card":"missionCard_card__w_YYq","imgWrap":"missionCard_imgWrap__5Na8V","title":"missionCard_title__1VPHv","desc":"missionCard_desc__1Di3a"};